import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { HeroSection } from './components/HeroSection';
import { HeroTestimonials } from './components/HeroTestimonials';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-black text-[var(--cream)]" data-id="element-0" data-mp="28sbbx5a2f776">
      <main data-id="element-1" data-mp="23ujmchww7x65">
        <HeroSection data-id="element-2" data-mp="23ut9lxqjzq85" />
        <HeroTestimonials data-id="element-3" data-mp="23ti7s3go4sjo" />
        <ProblemSection data-id="element-4" data-mp="3ikh7o8icgqyg" />
        <TomosSection data-id="element-5" data-mp="3iiwasc8k4vxf" />
        <BonosSection data-id="element-6" data-mp="3ijpd910hgz9r" />
        <OfferSection data-id="element-7" data-mp="3ii4ppvcl6gle" />
        <TestimonialsSection data-id="element-8" data-mp="3ml1397n9rmih" />
        <GuaranteeSection data-id="element-9" data-mp="3mk84asujy1aw" />
        <FaqSection data-id="element-10" data-mp="3mjg7xft4rzjk" />
        <CostSection data-id="element-11" data-mp="3rc9hqi3ghy2i" />
        <FinalCtaSection data-id="element-12" data-mp="3rbzmaezn6ypf" />
      </main>
      <Footer data-id="element-13" data-mp="3rd1all5o5hp3" />
    </div>;
}